import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class ProcessMapping extends BasicEntity {
inField: string;
inFieldType: string;
outField: string;
outFieldType: string;
outFieldValuePrefix: string;
processCode: string;
visionCode: string;
}

